import type { Risk_Assessment_Result_Control_Type_Enum } from '@risksmart-app/web-graphql-client/generated/graphql';
import type { FC } from 'react';

import { useIsFeatureVisibleToOrg } from '@/utils/featureFlags';

import { HeatmapWidgetCloudscape } from './HeatmapWidget.cloudscape';
import { HeatmapWidgetHighcharts } from './HeatmapWidget.highcharts';
import type { CellClickData, HeatmapCellData } from './types';

type Props = {
  loading?: boolean;
  /** [y-axis][x-axis] */
  data: HeatmapCellData[][];
  onCellClick?: (data: CellClickData) => void;
  controlType: Risk_Assessment_Result_Control_Type_Enum;
};

const HeatmapWidget: FC<Props> = (props) => {
  const highchartsEnabled = useIsFeatureVisibleToOrg('highcharts');

  if (highchartsEnabled) {
    return <HeatmapWidgetHighcharts {...props} />;
  }

  return <HeatmapWidgetCloudscape {...props} />;
};

export default HeatmapWidget;
